import { InputModeState, TableSection } from '../types';

export const calculateFieldDisabled = (
  inputModeState: InputModeState,
  tableSection: TableSection
): boolean => {
  const { hasAdjustmentInput, hasClosingInput, amountMode, sharesMode } = inputModeState;

  if (!amountMode && !sharesMode) {
    return false;
  }

  // If modes are different, do not disable (it was possible to have both inputs)
  if (amountMode && sharesMode && amountMode !== sharesMode) {
    return false;
  }

  const isAdjustmentField =
    tableSection === TableSection.AmountAdjustment ||
    tableSection === TableSection.SharesAdjustment;
  const isClosingField =
    tableSection === TableSection.AmountClosingBalance ||
    tableSection === TableSection.SharesClosingBalance;

  if (hasAdjustmentInput && isClosingField) {
    return true;
  }

  if (hasClosingInput && isAdjustmentField) {
    return true;
  }

  return false;
};
